"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importStar(require("react"));
const HeaderItems_1 = __importDefault(require("./HeaderItems"));
const MobileMenu_1 = __importDefault(require("./MobileMenu/MobileMenu"));
const Hooks_1 = require("@/Hooks");
const Theme_1 = require("@/Theme");
const react_redux_1 = require("react-redux");
const Modal_1 = __importDefault(require("../../UI/Modal"));
const MiniCart_1 = __importDefault(require("../../MiniCart/MiniCart"));
const useHeaderData_1 = __importDefault(require("../../../Hooks/useHeaderData"));
const useUserData_1 = __importDefault(require("../../../Hooks/useUserData"));
const Utils_1 = require("@/Utils");
const Header = () => {
    var _a;
    const { width } = (0, Hooks_1.useWindowSize)();
    const [activeRegion, setActiveRegion] = (0, react_1.useState)();
    const userData = (0, useUserData_1.default)();
    const headerData = (0, useHeaderData_1.default)();
    const isNorthAmerica = (0, react_redux_1.useSelector)((state) => state.initialData.isNorthAmerica);
    (0, react_1.useEffect)(() => {
        if ((headerData === null || headerData === void 0 ? void 0 : headerData.currentLanguage) && (headerData === null || headerData === void 0 ? void 0 : headerData.currentRegion)) {
            setActiveRegion(`${headerData.currentRegion} - ${headerData.currentLanguage}`);
        }
    }, [headerData === null || headerData === void 0 ? void 0 : headerData.currentLanguage, headerData === null || headerData === void 0 ? void 0 : headerData.currentRegion]);
    const isMiniCartOpen = (0, react_redux_1.useSelector)((state) => state.cart.isOpen);
    const miniCartData = (0, react_redux_1.useSelector)((state) => state.cart.cartData);
    const cartPage = (0, react_redux_1.useSelector)((state) => { var _a; return (_a = state.header.header) === null || _a === void 0 ? void 0 : _a.cartPage; });
    if (!headerData || (((_a = headerData === null || headerData === void 0 ? void 0 : headerData.menuData) === null || _a === void 0 ? void 0 : _a.length) === 0 && !(headerData === null || headerData === void 0 ? void 0 : headerData.settings))) {
        return null;
    }
    if (width < Theme_1.theme.breakpoints.xxl && headerData) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(MobileMenu_1.default, { headerData: headerData, activeRegion: activeRegion, isRegional: headerData.hasCart, showMiniCartIcon: (0, Utils_1.miniCartVisibility)(userData, cartPage, isNorthAmerica) }),
            isMiniCartOpen && (react_1.default.createElement(Modal_1.default, { isModalOpen: isMiniCartOpen, alwaysOnScreen: true },
                react_1.default.createElement(MiniCart_1.default, { lineItems: miniCartData.lineItems, totalPrice: miniCartData.totalPrice, isModalOpen: isMiniCartOpen, summary: miniCartData.summary })))));
    }
    else if (headerData) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HeaderItems_1.default, { headerData: headerData, activeRegion: activeRegion, isRegional: headerData.hasCart, showMiniCartIcon: (0, Utils_1.miniCartVisibility)(userData, cartPage, isNorthAmerica) }),
            isMiniCartOpen && (react_1.default.createElement(Modal_1.default, { isModalOpen: isMiniCartOpen, alwaysOnScreen: true },
                react_1.default.createElement(MiniCart_1.default, { lineItems: miniCartData.lineItems, totalPrice: miniCartData.totalPrice, isModalOpen: isMiniCartOpen, summary: miniCartData.summary })))));
    }
    else {
        return null;
    }
};
exports.Header = Header;
exports.default = exports.Header;
